import { Element, useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import type { SponsorLayout } from "src/types";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import Text from "@/components/editor/primitives/text/text-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import SponsorsSettings from "@/components/editor/shared/sponsors/sponsors-settings/sponsors-settings-component";

import { PaddingWrapper, StyledList } from "./sponsors-component-styles";

type SponsorsProps = {
  children: React.ReactNode;
  layout: SponsorLayout;
  title: string;
};

export default function Sponsors({ children, title, layout }: SponsorsProps) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  const numOfCols = layout === "golden" ? 3 : layout === "silver" ? 4 : 6;

  return (
    <BlockBackgroundColorWrapper ref={connect} id={nodeId}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper maxWidth={rem(1250)}>
          <div className="flex justify-center">
            <Element
              id="sponsor-title"
              is={Text}
              element="h2"
              text={title}
              pattern="headingTwo"
            />
          </div>
          <StyledList numOfCols={numOfCols}>{children}</StyledList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

Sponsors.craft = {
  custom: {
    displayName: "Sponsors",
  },
  isCanvas: true,
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
    settings: SponsorsSettings,
  },
};
